import axios from "axios";
import { applyHmacToAxiosConfig } from './hmacUtils'


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // replace with your API base URL



// API request function
export const apiRequest = async (endpoint, method, data = null, headers = {}) => {
  const url = `${API_BASE_URL}/${endpoint}`; // Ensure the URL is constructed properly

  const options = {
    method: method,
    headers: {
      ...(data instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
  };


  if (data) {
    options.data = data;
  }

  options.url = url;
  applyHmacToAxiosConfig(options);

  try {
    const response = await axios(url, options);

    if (!response) {
      throw new Error(`Error: ${response.status}`);
    }

    return response;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};
